module.exports = __webpack_public_path__ + "img/vertical_6_7_7016.4049b7d3.png";